import React, { useEffect, useRef, useState } from "react";
import "./sendMessage.scss";
import PropTypes from "prop-types";
import ajiConfig from "../../ajiConfig";

const SendMessage = ({
  handleInputChange,
  userInput,
  handleSendMessage,
  isChatting,
  sendMessageDisableIcon,
  sendMessageIcon,
  monthSub,
  QACount,
}) => {
  const [isFocusing, setIsFocusing] = useState(false);
  const textareaRef = useRef(null);

  // 自動調整textarea高度
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      let newHeight = textareaRef.current.scrollHeight;
      if (newHeight > 85) {
        newHeight = 85;
      }
      textareaRef.current.style.height = `${newHeight}px`;
    }
  }, [userInput]);

  const enterKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleInputFocus = (type) => {
    setIsFocusing(type);
  };

  return (
    <div
      className="sendMessageGroup"
      style={{
        border: isFocusing && "1px solid #BDE7FA",
        boxShadow: isFocusing && "0px 0px 8px 0px #096C9B1A",
      }}
    >
      <textarea
        className="sendMessageInput"
        type="text"
        onChange={handleInputChange}
        value={userInput}
        ref={textareaRef}
        rows={1}
        onKeyDown={enterKeyDown}
        onFocus={() => {
          handleInputFocus(true);
        }}
        onBlur={() => {
          handleInputFocus(false);
        }}
        placeholder="請輸入"
      />
      <button
        type="button"
        className="sendMessageButton"
        onClick={handleSendMessage}
        disabled={isChatting && QACount >= ajiConfig.quota}
        style={{
          cursor:
            !isChatting && userInput && (QACount < ajiConfig.quota || monthSub)
              ? "pointer"
              : "default",
        }}
      >
        <img
          src={
            isFocusing && !isChatting && (QACount < ajiConfig.quota || monthSub)
              ? sendMessageIcon
              : sendMessageDisableIcon
          }
          alt="sendMessageIcon"
        />
      </button>
    </div>
  );
};

SendMessage.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  userInput: PropTypes.string.isRequired,
  handleSendMessage: PropTypes.func.isRequired,
  isChatting: PropTypes.bool.isRequired,
  sendMessageIcon: PropTypes.string.isRequired,
  sendMessageDisableIcon: PropTypes.string.isRequired,
  monthSub: PropTypes.bool.isRequired,
  QACount: PropTypes.number.isRequired,
};

export default SendMessage;
